<template>
    <div class="row">
        <div class="small-12 medium-9 large-6 columns">
            <p
                v-bind:class="fourIcons ? 'footer-header-underlined large-13' : 'footer-header-underlined large-10'"
                v-html="logoSection.TitlePrimary"
            />
            <div v-bind:class="fourIcons ? 'row small-up-1 medium-up-4': 'row small-up-1 medium-up-3'">
                <div v-if="logoSection.LbLogoSectionElement?.Image" class="columns">
                    <footer-logo-image :model="logoSection.LbLogoSectionElement" />
                </div>

                <div v-if="logoSection.BautaLogoSectionElement?.Image" class="columns">
                    <footer-logo-image :model="logoSection.BautaLogoSectionElement" />
                </div>

                <div v-if="logoSection.RunaLogoSectionElement?.Image" class="columns">
                    <footer-logo-image :model="logoSection.RunaLogoSectionElement" />
                </div>

                <div v-if="logoSection.LbErhvervSectionElement?.Image" class="columns">
                    <footer-logo-image :model="logoSection.LbErhvervSectionElement" />
                </div>
            </div>
        </div>
        <div class="small-12 medium-3 show-for-medium-only columns">
            <footer-service-navigation :model="serviceNavigation" />
        </div>
        <div v-if="logoSection.TitleSecondary || logoSection.LbPFALogoSectionElement?.Image" class="small-12 medium-5 large-3 columns">
            <p
                class="footer-header-underlined"
                v-html="logoSection.TitleSecondary"
            />
            <div v-if="logoSection.LbPFALogoSectionElement.Image" class="row">
                <div class="columns">
                    <footer-logo-image
                        :model="logoSection.LbPFALogoSectionElement"
                        class="pfa"
                    />
                </div>
            </div>
        </div>
        <div v-bind:class="logoSection.TitleSecondary ? 'small-12 large-2 large-offset-1 hide-for-medium-only columns' : 'small-12 large-2 large-offset-4 hide-for-medium-only columns'">
            <footer-service-navigation :model="serviceNavigation" />
        </div>
    </div>
</template>

<script  lang="ts">
import FooterLogoImage from './FooterLogoImage.vue';
import FooterServiceNavigation from './FooterServiceNavigation.vue';

export default {
    name: 'FooterBottomRow',
    components: {
        FooterLogoImage,
        FooterServiceNavigation
    },
    props: {
        logoSection: {
            type: Object,
            default() {
                return {
                    Logos: {}
                };
            }
        },
        serviceNavigation: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        fourIcons() : boolean {
            return (this.logoSection.LbLogoSectionElement?.Image != null && this.logoSection.BautaLogoSectionElement?.Image != null && this.logoSection.RunaLogoSectionElement?.Image != null && this.logoSection.LbErhvervSectionElement?.Image != null);
        },
  },
};
</script>
